import { Component } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import addComponentAnimation from '@swisslife/shared-ui/src/utils/animations/js/animations';
import '../../teaser-row/js/teaser-row';

enum Selectors {
	Title = '.js-m-purpose-hub-teaser__title-wrapper',
}
@Component('PurposeHubTeaser')
export class PurposeHubTeaser extends GondelJqueryComponent {
	private controllersTitle: any[] = Array();

	public async sync() {
		this.controllersTitle = await addComponentAnimation(this.$ctx, Selectors.Title);
	}

	public stop() {
		for (const controller of this.controllersTitle) {
			controller.destroy(true);
		}
	}
}
